import {Button, BUTTON_THEMES} from 'components/Button';
import {useCatalogRoutes} from 'core/modules/routing/hooks/useCatalogRoutes';
import {IWineShop} from 'modules/wineshops-list/models';
import React, {memo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import {ProductsPageBlock} from 'modules/products/components/ProductsPageBlock';
import {BlockTitle} from '../BlockTitle';
import {IProductShort} from 'modules/products/types';

interface IProps {
    products?: IProductShort[];
    shop: IWineShop;
}

export const WineShopProducts = memo<IProps>(function WineShopProducts({products, shop}) {
    const {
        wine: {url},
    } = useCatalogRoutes();
    const cityId = shop.cityId;

    const slug = shop?.catalogFilterSlug || '';

    const allProductWineShopHref = `${url()}/filter/vinoteka-${slug}${cityId ? `/?setVisitorCityId=${cityId}` : ''}`;

    return (
        <>
            <BlockTitle className={style.blockTitle}>
                <a className={style.titleWrapper} href={allProductWineShopHref}>
                    <Typography className={style.titleText} element={'h2'} variant={'headline-32-m'}>
                        Ассортимент винотеки
                    </Typography>
                </a>
            </BlockTitle>
            <ProductsPageBlock products={products} />
            <div className={style.btnContainer}>
                <Button className={style.btn} href={allProductWineShopHref} theme={BUTTON_THEMES.secondary}>
                    Cмотреть все товары
                </Button>
            </div>
        </>
    );
});
